export default __webpack_public_path__ + "static/media/02C.95d47c3d.png";